import * as Yup from 'yup'
import { FinanceProfilePaymentFormsEnum } from '@/types'

export const schemaPayment = (t: (key: string) => string) => ({
  paymentFormOption: Yup.string().required(t('requiredMessage')),
  paymentMethodOption: Yup.string().required(t('requiredMessage')),
  creditTerm: Yup.string().when(
    'paymentFormOption',
    (paymentFormOption, schema) => {
      if (paymentFormOption[0] === FinanceProfilePaymentFormsEnum.credit) {
        return schema.required(t('requiredMessage'))
      }
      return schema.notRequired()
    },
  ),
  financingCost: Yup.string().when(
    'paymentFormOption',
    (paymentFormOption, schema) => {
      if (paymentFormOption[0] === FinanceProfilePaymentFormsEnum.credit) {
        return schema.required(t('requiredMessage'))
      }
      return schema.notRequired()
    },
  ),
})
